/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminIncrementSyncPositionRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AdminIncrementSyncPositionResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const adminIncrementSyncPosition = (request:AdminIncrementSyncPositionRequest, options?: CashRequestOptions) => post<AdminIncrementSyncPositionRequest, AdminIncrementSyncPositionResponse>("/2.0/cash/admin-increment-sync-position", request, {...options, rejectOnError: true })